import React from 'react';
import { Router } from '@uhg-abyss/web/ui/Router';
import { CommonFooter } from '@/common/Layouts/Footer';
import { CommonHeader } from '@/common/Layouts/CommonHeader';
import { AppLayoutBody } from './AppLayout.styles';

export const AppLayout = () => {
  return (
    <React.Fragment>
      {/* header */}
      <div id="global-header">
        <CommonHeader />
      </div>
      {/* main */}
      <div id="global-main">
        <AppLayoutBody>
          <Router.Outlet />
        </AppLayoutBody>
      </div>
      {/* footer */}
      <div id="global-footer">
        <CommonFooter />
      </div>
    </React.Fragment>
  );
};
